import { 
  HeroSlideItem, ProjectItem, EquipmentItem, EventItem, 
  DistributionTitle, TeamMember, PartnerItem, MarketingProjectItem, 
  NewsArticle, SiteContentConfig, BrandSettings, SEOSettings, StargazeWorldItem,
  CustomPage, NavigationMenu, ThemeCustomizerSettings
} from '../types';
import { 
  INITIAL_PROJECTS, INITIAL_EQUIPMENT, INITIAL_EVENTS, 
  INITIAL_DISTRIBUTION, INITIAL_NEWS 
} from './mockData';

export const INITIAL_STARGAZE_WORLDS: StargazeWorldItem[] = [
  {
    id: 'films',
    code: '01',
    name: 'FILMS',
    buttonLabel: 'FILMS',
    tagline: 'ORIGINAL CINEMA & EPISODIC SLATE',
    desc: 'Feature film co-productions, high-concept drama, and streaming series crafted with uncompromising cinematic ambition.',
    imageUrl: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1200&q=80',
    iconName: 'Film',
    link: '/films',
    stats: 'Saheb Vikas Kari • Psycho',
    displayOrder: 1,
    status: 'PUBLISHED',
    visible: true,
  },
  {
    id: 'events',
    code: '02',
    name: 'EVENTS',
    buttonLabel: 'EVENTS',
    tagline: 'PREMIERES & LIVE CONCERTS',
    desc: 'Immersive live music concert tours, theatrical premiere galas, and cultural showcases featuring headline performing artists.',
    imageUrl: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1200&q=80',
    iconName: 'Sparkles',
    link: '/events',
    stats: 'Father & Son Duo Live Tour',
    displayOrder: 2,
    status: 'PUBLISHED',
    visible: true,
  },
  {
    id: 'rental',
    code: '03',
    name: 'RENTAL',
    buttonLabel: 'RENTAL',
    tagline: 'TECHNICAL CAMERA DEPARTMENT',
    desc: 'ARRI ALEXA 35, Sony Venice, Cooke Anamorphic optics, Angénieux zooms, and professional camera movement packages.',
    imageUrl: 'https://images.unsplash.com/photo-1512790182412-b19e6d62bc39?auto=format&fit=crop&w=1200&q=80',
    iconName: 'Camera',
    link: '/rental',
    stats: 'ARRI Alexa 35 & Cooke Optics',
    displayOrder: 3,
    status: 'PUBLISHED',
    visible: true,
  },
  {
    id: 'distribution',
    code: '04',
    name: 'DISTRIBUTION',
    buttonLabel: 'DISTRIBUTION',
    tagline: 'THEATRICAL & GLOBAL RIGHTS',
    desc: 'Multi-territory theatrical release circuits, satellite syndication, OTT platform partnerships, and festival promotion.',
    imageUrl: 'https://images.unsplash.com/photo-1509198397868-475647b2a1e5?auto=format&fit=crop&w=1200&q=80',
    iconName: 'Globe',
    link: '/distribution',
    stats: 'Worldwide & Domestic Syndication',
    displayOrder: 4,
    status: 'PUBLISHED',
    visible: true,
  },
  {
    id: 'experiences',
    code: '05',
    name: 'EXPERIENCES',
    buttonLabel: 'EXPERIENCES',
    tagline: 'FAN EXPERIENCES & SPECIAL SCREENINGS',
    desc: 'Director masterclasses, VIP festival screenings, red carpet galas, and bespoke audio-visual installations.',
    imageUrl: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1200&q=80',
    iconName: 'Award',
    link: '/experiences',
    stats: 'Curated Cultural Shows',
    displayOrder: 5,
    status: 'PUBLISHED',
    visible: true,
  },
  {
    id: 'pr-marketing',
    code: '06',
    name: 'PR & MARKETING',
    buttonLabel: 'PR & MARKETING',
    tagline: 'THEATRICAL PUBLICITY & CIVIC CAMPAIGNS',
    desc: 'Strategic publicity syndication, social impact campaigns (Nagpur Police 112), digital marketing, and theatrical promotions.',
    imageUrl: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=1200&q=80',
    iconName: 'TrendingUp',
    link: '/marketing',
    stats: 'Nagpur Police 112 Campaign',
    displayOrder: 6,
    status: 'PUBLISHED',
    visible: true,
  },
];

export const INITIAL_HERO_SLIDES: HeroSlideItem[] = [
  {
    id: 'hero-saheb-vikaskari',
    title: 'SAHEB VIKAS KARI',
    category: 'FEATURE FILM',
    projectRef: 'saheb-vikaskari',
    eyebrow: '01 // FEATURE FILM PREMIERE',
    description: 'Presented by Satish Mohod, Orange City Production. Written by Vaibhav Arjun Parab. Starring Kyra Agrawal, Satish Mohod, Shrutika Nikode, and Swapnil Bhongade.',
    desktopMediaId: '',
    mobileMediaId: '',
    desktopSrc: '',
    mobileSrc: '',
    desktopFocalPoint: { x: 50, y: 50 },
    mobileFocalPoint: { x: 50, y: 50 },
    caption: 'Official Theatrical Release & Multi-Territory Distribution',
    ctaLabel: 'VIEW PROJECT',
    ctaDestination: '/projects',
    status: 'PUBLISHED',
    displayOrder: 1,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'hero-nayi-soch',
    title: 'NAYI SOCH (112)',
    category: 'SHORT FILM',
    projectRef: 'nayi-soch-112',
    eyebrow: '02 // SOCIAL AWARENESS SHORT FILM',
    description: 'An impactful short film produced by Satish Tulshiramji Mohod in collaboration with Nagpur Police, featuring Mohana Ramteke. Highlighting safety, awareness, and social transformation.',
    desktopMediaId: '',
    mobileMediaId: '',
    desktopSrc: '',
    mobileSrc: '',
    desktopFocalPoint: { x: 50, y: 50 },
    mobileFocalPoint: { x: 50, y: 50 },
    caption: 'In Collaboration with Nagpur Police',
    ctaLabel: 'EXPLORE FILM',
    ctaDestination: '/projects',
    status: 'PUBLISHED',
    displayOrder: 2,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'hero-psycho',
    title: 'PSYCHO (SAMJO TO)',
    category: 'AWARD-WINNING DRAMA',
    projectRef: 'psycho',
    eyebrow: '03 // AWARD-WINNING DRAMA',
    description: 'Produced by Satish Mohod (Orange City Production). Official selections at New Delhi Film Festival, DPIFF Awards, Lift-Off Global Network, and Mumba International Short Film Festival.',
    desktopMediaId: '',
    mobileMediaId: '',
    desktopSrc: '',
    mobileSrc: '',
    desktopFocalPoint: { x: 50, y: 50 },
    mobileFocalPoint: { x: 50, y: 50 },
    caption: 'Multi-Festival Official Selection',
    ctaLabel: 'EXPLORE SLATE',
    ctaDestination: '/projects',
    status: 'PUBLISHED',
    displayOrder: 3,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'hero-father-son',
    title: 'FATHER & SON DUO',
    category: 'LIVE ENTERTAINMENT',
    projectRef: 'father-son-duo',
    eyebrow: '04 // LIVE ENTERTAINMENT & CINEMA',
    description: 'An unforgettable musical journey featuring renowned artists Narayan Mohod & Satish Mohod. Production, audio, and visual spectacles by Orange City Production.',
    desktopMediaId: '',
    mobileMediaId: '',
    desktopSrc: '',
    mobileSrc: '',
    desktopFocalPoint: { x: 50, y: 50 },
    mobileFocalPoint: { x: 50, y: 50 },
    caption: 'Live Concert & Touring Spectacle',
    ctaLabel: 'EXPLORE EVENTS',
    ctaDestination: '/events',
    status: 'PUBLISHED',
    displayOrder: 4,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const INITIAL_TEAM_MEMBERS: TeamMember[] = [
  {
    id: 'team-satish-mohod',
    name: 'Satish Mohod',
    role: 'Founder, Managing Director & Producer',
    shortBio: 'Visionary film producer, director, and performing artist leading Stargaze Media and Orange City Production.',
    fullBio: 'Satish Mohod has produced acclaimed cinematic ventures including Saheb Vikas Kari, Nayi Soch (in collaboration with Nagpur Police), and the award-winning short Psycho. He also leads prestigious live performance engagements across the nation.',
    portraitUrl: '',
    portraitMediaId: '',
    displayOrder: 1,
    featured: true,
    status: 'PUBLISHED',
    focalPoint: { x: 50, y: 40 },
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'team-narayan-mohod',
    name: 'Narayan Mohod',
    role: 'Co-Founder & Musical Maestro',
    shortBio: 'Renowned vocalist, instrumental composer, and co-creator of the Father & Son Duo live experience.',
    fullBio: 'With decades of musical virtuosity, Narayan Mohod anchors Stargaze Media’s cultural roots and musical scoring department, performing for prestigious cultural stages across India.',
    portraitUrl: '',
    portraitMediaId: '',
    displayOrder: 2,
    featured: true,
    status: 'PUBLISHED',
    focalPoint: { x: 50, y: 40 },
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'team-nikhil-shirbhate',
    name: 'Nikhil Vasantrao Shirbhate',
    role: 'Executive Director & Studio Operations',
    shortBio: 'Directs studio infrastructure, equipment logistics, and post-production operations across Western India.',
    fullBio: 'Oversees Stargaze Media’s cutting-edge cinema rental catalog, workflow logistics, camera packages, and technical production management.',
    portraitUrl: '',
    portraitMediaId: '',
    displayOrder: 3,
    featured: true,
    status: 'PUBLISHED',
    focalPoint: { x: 50, y: 40 },
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'team-orange-city',
    name: 'Orange City Production',
    role: 'Production Execution Hub',
    shortBio: 'The core production partner behind Stargaze Media’s cinematic, digital, and broadcast initiatives.',
    fullBio: 'Facilitates complete pre-production, on-location camera crew logistics, lighting packages, and seamless post-production execution for regional and national features.',
    portraitUrl: '',
    portraitMediaId: '',
    displayOrder: 4,
    featured: false,
    status: 'PUBLISHED',
    focalPoint: { x: 50, y: 50 },
    updatedAt: new Date().toISOString(),
  },
];

export const INITIAL_PARTNERS: PartnerItem[] = [
  {
    id: 'partner-pandav',
    name: 'Pandav Enterprises',
    logoUrl: '',
    logoMediaId: '',
    website: '',
    description: 'Premier cinema production & theatrical co-creation collaborator.',
    category: 'PRODUCTION',
    displayOrder: 1,
    featured: true,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'partner-dawn-studio',
    name: 'Dawn Studio',
    logoUrl: '',
    logoMediaId: '',
    website: '',
    description: 'State-of-the-art post-production, VFX compositing, and visual mastering partner.',
    category: 'POST_PRODUCTION_VFX',
    displayOrder: 2,
    featured: true,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'partner-ufo-janta',
    name: 'UFO / Janta Cinema',
    logoUrl: '',
    logoMediaId: '',
    website: '',
    description: 'Digital cinema delivery network and theatrical exhibition partner across regional circuits.',
    category: 'EXHIBITION',
    displayOrder: 3,
    featured: true,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'partner-m-otb',
    name: 'M-OTB',
    logoUrl: '',
    logoMediaId: '',
    website: '',
    description: 'Specialized media solutions and creative production partner.',
    category: 'MEDIA_PRODUCTION',
    displayOrder: 4,
    featured: true,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'partner-sapta-records',
    name: 'Sapta Records',
    logoUrl: '',
    logoMediaId: '',
    website: '',
    description: 'Film audio recording, soundtrack production, and musical label collaborator.',
    category: 'MUSIC_AUDIO',
    displayOrder: 5,
    featured: true,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'partner-khushi-hungama',
    name: 'Khushi Advertising / Hungama Media',
    logoUrl: '',
    logoMediaId: '',
    website: '',
    description: 'Cinema advertising network, entertainment PR, digital syndication, and multimedia marketing.',
    category: 'MARKETING_PR',
    displayOrder: 6,
    featured: true,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'partner-anikesh-trivedi',
    name: 'Anikesh Trivedi (VFX)',
    logoUrl: '',
    logoMediaId: '',
    website: '',
    description: 'High-end visual effects supervision, photorealistic 3D CGI, and digital optical compositing.',
    category: 'VFX_ARTIST',
    displayOrder: 7,
    featured: true,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'partner-jasinto',
    name: 'Jasinto (Worldwide Distribution)',
    logoUrl: '',
    logoMediaId: '',
    website: '',
    description: 'International film distribution agency managing multi-territory theatrical & OTT sales.',
    category: 'WORLDWIDE_DISTRIBUTION',
    displayOrder: 8,
    featured: true,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
];

export const INITIAL_MARKETING_PROJECTS: MarketingProjectItem[] = [
  {
    id: 'mkt-nagpur-112',
    title: 'Nagpur Police 112 Emergency Citizen Campaign',
    category: 'Public Safety & PR Campaign',
    description: 'Multichannel awareness campaign designed to familiarize the public with the 112 emergency response network.',
    client: 'Nagpur Police Department',
    services: ['Short Film Production', 'Digital PR', 'Broadcast Placement', 'Social Content'],
    results: 'Reached over 1.2 million citizens across Vidarbha and amplified emergency hotline response adoption.',
    featured: true,
    displayOrder: 1,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'mkt-psycho-festivals',
    title: 'Psycho International Film Festival PR Campaign',
    category: 'Entertainment Marketing',
    description: 'Targeted festival submission, critical screening curation, and awards PR for the psychological drama Psycho.',
    client: 'Orange City Production',
    services: ['Festival PR', 'Digital Press Kit', 'Jury Screenings', 'Global Awards Campaign'],
    results: 'Four prestigious festival selections and critical acclaim across international circuits.',
    featured: true,
    displayOrder: 2,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'mkt-saheb-theatrical',
    title: 'Saheb Vikas Kari Regional Theatrical Launch',
    category: 'Theatrical Marketing',
    description: 'Comprehensive regional film promotional tour, press conference coordination, and digital trailer rollout.',
    client: 'Stargaze Media & Orange City Production',
    services: ['Theatrical Trailers', 'Hoardings & Outdoor', 'Press Conferences', 'Talent Tours'],
    results: 'High anticipation release with multi-theater coverage in Maharashtra.',
    featured: true,
    displayOrder: 3,
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  },
];

export const INITIAL_SITE_CONTENT: SiteContentConfig = {
  homepageSections: {
    hero: {
      id: 'hero',
      enabled: true,
      eyebrow: 'FLAGSHIP ENTERTAINMENT STUDIO',
      heading: 'WE CREATE WHAT THE WORLD WATCHES',
      description: 'Production • Post-Production • Camera Equipment • Distribution • Entertainment Experiences',
      ctaLabel: 'EXPLORE SLATE',
      ctaDestination: '/projects',
      displayOrder: 1,
    },
    brandStatement: {
      id: 'brandStatement',
      enabled: true,
      eyebrow: '01 // BRAND VISION & PURPOSE',
      heading: '“WE BELIEVE IN THE TRANSFORMATIVE POWER OF CINEMA TO CONNECT PEOPLE, SHAPE PERSPECTIVES, AND INFLUENCE CULTURE.”',
      description: 'Our vision is to create meaningful, globally relevant stories that combine creative excellence, innovation, and emotional impact—building a future where our work transcends screens and leaves a lasting cultural footprint.',
      ctaLabel: 'OUR CAPABILITIES',
      ctaDestination: '/capabilities',
      displayOrder: 2,
    },
    universe: {
      id: 'universe',
      enabled: true,
      eyebrow: '02 // INTERACTIVE EXPLORATION',
      heading: 'ENTER THE STARGAZE UNIVERSE',
      description: 'Explore the interconnected pillars of our cinematic house — from script development to high-tier camera rentals and multi-territory film distribution.',
      displayOrder: 3,
    },
    featuredWork: {
      id: 'featuredWork',
      enabled: true,
      eyebrow: '03 // FEATURED CINEMA SLATE',
      heading: 'CURATED PRODUCTIONS',
      description: 'Groundbreaking cinema crafted with passion, precision, and world-class production values.',
      ctaLabel: 'VIEW ALL FILMS',
      ctaDestination: '/projects',
      displayOrder: 4,
    },
    capabilities: {
      id: 'capabilities',
      enabled: true,
      eyebrow: '04 // FULL-SPECTRUM STUDIO SERVICES',
      heading: 'END-TO-END PRODUCTION MASTERY',
      description: 'Pre-production script development, on-set cinematography, sound stages, VFX mastering, censor certification, and international distribution.',
      ctaLabel: 'STUDIO SUITE',
      ctaDestination: '/capabilities',
      displayOrder: 5,
    },
    equipment: {
      id: 'equipment',
      enabled: true,
      eyebrow: '05 // CINEMA GEAR RENTAL',
      heading: 'HOLLYWOOD-GRADE CAMERA & OPTICS DEPARTMENT',
      description: 'ARRI Alexa 35, ARRI Alexa SXT Plus, Sony Venice, FX6, Ultra Primes, Optimo Zooms, and advanced DOP support kits.',
      ctaLabel: 'BROWSE EQUIPMENT',
      ctaDestination: '/equipment',
      displayOrder: 6,
    },
    distribution: {
      id: 'distribution',
      enabled: true,
      eyebrow: '06 // GLOBAL LICENSING & SYNDICATION',
      heading: 'WORLDWIDE DISTRIBUTION SLATE',
      description: 'Connecting groundbreaking regional and national cinema with international buyers, OTT platforms, and theatrical circuits.',
      ctaLabel: 'VIEW TITLES',
      ctaDestination: '/distribution',
      displayOrder: 7,
    },
    experiences: {
      id: 'experiences',
      enabled: true,
      eyebrow: '07 // LIVE ACTIVATIONS',
      heading: 'PREMIERES & LIVE EXPERIENCES',
      description: 'Red-carpet galas, film festival premieres, touring musical concerts, and immersive entertainment.',
      ctaLabel: 'EXPLORE EVENTS',
      ctaDestination: '/events',
      displayOrder: 8,
    },
    newsroom: {
      id: 'newsroom',
      enabled: true,
      eyebrow: '08 // PRESS & ANNOUNCEMENTS',
      heading: 'STARGAZE NEWSROOM',
      description: 'Official press releases, festival triumphs, production announcements, and industry insights.',
      ctaLabel: 'READ ALL INSIGHTS',
      ctaDestination: '/news',
      displayOrder: 9,
    },
    partners: {
      id: 'partners',
      enabled: true,
      eyebrow: '09 // INDUSTRY COLLABORATORS',
      heading: 'COLLABORATIVE EXCELLENCE',
      description: 'Proud to create alongside governmental bodies, premier production houses, and world-class media networks.',
      displayOrder: 10,
    },
    finalCta: {
      id: 'finalCta',
      enabled: true,
      eyebrow: 'CONNECT WITH THE STUDIO',
      heading: 'READY TO BRING YOUR VISION TO THE SCREEN?',
      description: 'Partner with Stargaze Media for comprehensive film production, premier camera equipment rentals, or global distribution representation.',
      ctaLabel: 'START STUDIO ENQUIRY',
      ctaDestination: '/enquiry',
      displayOrder: 11,
    },
  },
  universeSection: {
    eyebrow: '03 // STUDIO DIVISIONS',
    heading: 'DIVISIONS & SERVICES',
    description: 'Explore our six primary cinema divisions powering entertainment from development to global release.',
    worlds: INITIAL_STARGAZE_WORLDS,
  },
  brandStatement: {
    eyebrow: '01 // BRAND VISION & PURPOSE',
    heading: '“WE BELIEVE IN THE TRANSFORMATIVE POWER OF CINEMA TO CONNECT PEOPLE, SHAPE PERSPECTIVES, AND INFLUENCE CULTURE.”',
    description: 'Our vision is to create meaningful, globally relevant stories that combine creative excellence, innovation, and emotional impact—building a future where our work transcends screens and leaves a lasting cultural footprint.',
    highlightText: 'EVERY FRAME MATTERS. EVERY STORY DESERVES THE BIGGEST CANVAS.',
  },
  contactCopy: {
    introHeading: 'INITIATE PRODUCTION DIALOGUE',
    introDescription: 'Whether you require an ARRI Alexa camera package, full-scale feature film production, or theatrical distribution representation, our production executives are ready to assist.',
    officeAddress: 'Office No. 102, Adiraj Business Complex, Near Matoshree National School, Urit Nagar, Warje, Pune – 411058',
    email: 'info@stargazemedia.in',
    phone: '+91 98220 00000',
    workingHours: 'Monday – Saturday: 09:00 – 20:00 IST',
  },
  footerCopy: {
    tagline: 'Cinema • Production • Equipment • Distribution',
    copyrightText: `© ${new Date().getFullYear()} Stargaze Media Pvt. Ltd. All rights reserved.`,
  },
};

export const INITIAL_BRAND_SETTINGS: BrandSettings = {
  brandName: 'Stargaze Media',
  tagline: 'Cinema • Production • Equipment • Distribution',
  primaryLogoMediaId: '',
  primaryLogoUrl: '',
  altLogoMediaId: '',
  altLogoUrl: '',
  faviconMediaId: '',
  faviconUrl: '',
  socialSharingMediaId: '',
  socialSharingUrl: '',
  updatedAt: new Date().toISOString(),
};

export const INITIAL_SEO_SETTINGS: SEOSettings = {
  siteTitle: 'Stargaze Media | Cinematic Production, Equipment Rental & Distribution',
  metaDescription: 'Stargaze Media is a premier cinematic production studio, camera equipment rental house, and global film distribution company in India.',
  defaultSocialImageMediaId: '',
  defaultSocialImageUrl: '',
  ogTitle: 'Stargaze Media | We Create What The World Watches',
  ogDescription: 'Production, Post-Production, Hollywood-grade Camera Equipment Rental, and Worldwide Distribution.',
  twitterHandle: '@StargazeMedia',
  robotsIndex: true,
  updatedAt: new Date().toISOString(),
};

export const INITIAL_CUSTOM_PAGES: CustomPage[] = [
  {
    id: 'special-screenings',
    title: 'Special Screenings & Masterclasses',
    slug: 'special-screenings',
    description: 'Exclusive director masterclasses, private screenings, and premiere retrospectives.',
    status: 'PUBLISHED',
    template: 'default',
    seoTitle: 'Special Screenings & Masterclasses | Stargaze Media',
    seoDescription: 'Join industry masterclasses, private theatrical screenings, and panel discussions curated by Stargaze Media.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    blocks: [
      {
        id: 'block-hero-1',
        type: 'hero',
        title: 'Screening Hero Screen',
        styles: {
          paddingTop: 80,
          paddingBottom: 80,
          backgroundColor: '#09090b',
          textColor: '#ffffff',
          accentColor: '#d97706',
          backgroundImageUrl: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1600&q=80',
          backgroundOverlayOpacity: 75,
        },
        settings: {
          eyebrow: 'EXCLUSIVE CINEMA ACCESS',
          heading: 'SPECIAL SCREENINGS & MASTERCLASSES',
          subheading: 'Experience cinema with the visionaries who make it. Intimate 4K projection screenings, director Q&As, and cinematography masterclasses.',
          badge: 'LIMITED SEATING // VIP PASS',
          primaryBtnText: 'REQUEST ACCESS PASS',
          primaryBtnLink: '/enquiry',
          secondaryBtnText: 'EXPLORE SLATE',
          secondaryBtnLink: '/projects',
          align: 'center',
        },
      },
      {
        id: 'block-stats-1',
        type: 'stats_counter',
        title: 'Screening Stats',
        styles: {
          paddingTop: 40,
          paddingBottom: 40,
          backgroundColor: '#18181b',
          textColor: '#ffffff',
        },
        settings: {
          items: [
            { number: '48+', label: 'Masterclasses Hosted' },
            { number: '4K DCI', label: 'Reference Projection' },
            { number: 'Dolby Atmos', label: 'Immersive Soundstage' },
            { number: '1,200+', label: 'Filmmakers Trained' },
          ],
        },
      },
      {
        id: 'block-heading-1',
        type: 'heading',
        title: 'Programs Heading',
        styles: {
          paddingTop: 60,
          paddingBottom: 20,
          backgroundColor: '#ffffff',
          textColor: '#09090b',
          accentColor: '#d97706',
        },
        settings: {
          eyebrow: '01 // CURATED SESSIONS',
          heading: 'UPCOMING SCREENINGS & SESSIONS',
          subheading: 'Designed for professional filmmakers, cinematographers, and cinema enthusiasts.',
          align: 'center',
          showDivider: true,
        },
      },
      {
        id: 'block-features-1',
        type: 'feature_cards',
        title: 'Masterclass Offerings',
        styles: {
          paddingTop: 20,
          paddingBottom: 60,
          backgroundColor: '#ffffff',
          textColor: '#18181b',
        },
        settings: {
          columns: 3,
          cards: [
            {
              icon: 'Camera',
              title: 'Anamorphic Cinematography Workshop',
              description: 'Hands-on training with ARRI Alexa 35 and Cooke Anamorphic /i Full Frame Plus prime lenses.',
              badge: 'TECHNICAL LAB',
              linkText: 'Register Interest',
              linkUrl: '/enquiry',
            },
            {
              icon: 'Film',
              title: 'Director & Screenwriter Dialogue',
              description: 'Deconstructing narrative pacing, blocking actors for the widescreen frame, and working with top regional talent.',
              badge: 'MASTERCLASS',
              linkText: 'View Schedule',
              linkUrl: '/events',
            },
            {
              icon: 'Sliders',
              title: 'Dolby Atmos Sound & Color Grading',
              description: 'Deep dive into 8K HDR color pipelines, ACES workflows, and multi-channel object-based audio mixing.',
              badge: 'POST LAB',
              linkText: 'Book Suite Session',
              linkUrl: '/enquiry',
            },
          ],
        },
      },
      {
        id: 'block-cta-1',
        type: 'cta_banner',
        title: 'Screening Registration CTA',
        styles: {
          paddingTop: 60,
          paddingBottom: 60,
          backgroundColor: '#09090b',
          textColor: '#ffffff',
          accentColor: '#d97706',
        },
        settings: {
          eyebrow: 'JOIN THE NEXT COHORT',
          heading: 'RESERVE YOUR SEAT AT STARGAZE STUDIOS',
          description: 'Access priority bookings for upcoming premiere screenings and private industry showcases.',
          primaryBtnText: 'BOOK ATTENDANCE',
          primaryBtnLink: '/enquiry',
          secondaryBtnText: 'CONTACT DESK',
          secondaryBtnLink: '/about',
        },
      },
    ],
  },
  {
    id: 'studio-infrastructure',
    title: 'Studio Infrastructure & Stages',
    slug: 'studio-infrastructure',
    description: 'Explore our sound stages, color grading suites, and camera rental facility.',
    status: 'PUBLISHED',
    template: 'default',
    seoTitle: 'Studio Infrastructure & Production Stages | Stargaze Media',
    seoDescription: 'World-class sound stages, ARRI lighting grids, and post-production suites in Maharashtra.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    blocks: [
      {
        id: 'infra-hero',
        type: 'hero',
        title: 'Infrastructure Banner',
        styles: {
          paddingTop: 80,
          paddingBottom: 80,
          backgroundColor: '#09090b',
          textColor: '#ffffff',
          accentColor: '#d97706',
          backgroundImageUrl: 'https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?auto=format&fit=crop&w=1600&q=80',
          backgroundOverlayOpacity: 80,
        },
        settings: {
          eyebrow: 'PURPOSE-BUILT CINEMA FACILITY',
          heading: 'STUDIO INFRASTRUCTURE & SOUND STAGES',
          subheading: 'Engineered for seamless production from principal photography to final theatrical DCP delivery.',
          primaryBtnText: 'BOOK STAGE TOUR',
          primaryBtnLink: '/enquiry',
          secondaryBtnText: 'RENTAL CATALOG',
          secondaryBtnLink: '/equipment',
          align: 'center',
        },
      },
      {
        id: 'infra-rich-text',
        type: 'rich_text',
        title: 'Studio Narrative',
        styles: {
          paddingTop: 40,
          paddingBottom: 40,
          backgroundColor: '#ffffff',
          textColor: '#18181b',
        },
        settings: {
          content: '### A COMPLETE CINEMATIC ECOSYSTEM\n\nStargaze Media operates multi-acre production stages outfitted with sound dampening, heavy-duty motorized lighting grids, cycloramas, and dedicated DOP preparation bays.\n\nWhether shooting high-octane automotive chase sequences, dramatic interior dialogue, or virtual production backgrounds, our studios provide the electrical overhead, grip infrastructure, and technical crew needed to execute at the highest cinematic standard.',
        },
      },
      {
        id: 'infra-faq',
        type: 'faq_accordion',
        title: 'Infrastructure FAQ',
        styles: {
          paddingTop: 40,
          paddingBottom: 60,
          backgroundColor: '#f4f4f5',
          textColor: '#09090b',
        },
        settings: {
          eyebrow: 'FREQUENTLY ASKED QUESTIONS',
          heading: 'PRODUCTION & STAGE HIRE DETAILS',
          items: [
            {
              question: 'What power and electrical capacity is available on stage?',
              answer: 'Our main stages feature 200kW synchronized silent generator backups, 3-phase 63A distribution boxes, and DMX-controlled dimmer lines.',
            },
            {
              question: 'Can we hire camera and lighting packages on-site?',
              answer: 'Yes! Our rental floor is located directly adjacent to Stage A and Stage B, stocked with ARRI Alexa 35, Sony Venice 2, and Aputure/ARRI SkyPanels.',
            },
            {
              question: 'Are production offices and green rooms included?',
              answer: 'Each stage hire includes two fully air-conditioned vanity/green rooms, high-speed fiber internet, and executive production suites.',
            },
          ],
        },
      },
    ],
  },
];

export const INITIAL_NAVIGATION_MENUS: NavigationMenu[] = [
  {
    id: 'menu-header-primary',
    name: 'Primary Header Navigation',
    location: 'header_primary',
    updatedAt: new Date().toISOString(),
    items: [
      { id: 'nav-home', label: 'HOME', type: 'system', url: '/', target: '_self' },
      { id: 'nav-films', label: 'FILMS', type: 'system', url: '/films', target: '_self' },
      { id: 'nav-events', label: 'EVENTS', type: 'system', url: '/events', target: '_self' },
      { id: 'nav-rental', label: 'RENTAL', type: 'system', url: '/rental', target: '_self' },
      { id: 'nav-marketing', label: 'PR & MARKETING', type: 'system', url: '/marketing', target: '_self' },
      { id: 'nav-work', label: 'WORK', type: 'system', url: '/work', target: '_self' },
      { id: 'nav-contact', label: 'CONTACT', type: 'system', url: '/contact', target: '_self' },
      { id: 'nav-newsroom', label: 'NEWSROOM', type: 'system', url: '/newsroom', target: '_self' },
    ],
  },
  {
    id: 'menu-footer-quicklinks',
    name: 'Quick Links',
    location: 'footer_col_1',
    updatedAt: new Date().toISOString(),
    items: [
      { id: 'f-films', label: 'Films', type: 'system', url: '/films', target: '_self' },
      { id: 'f-events', label: 'Events', type: 'system', url: '/events', target: '_self' },
      { id: 'f-rental', label: 'Rental/Equipment', type: 'system', url: '/rental', target: '_self' },
      { id: 'f-distribution', label: 'Distribution', type: 'system', url: '/distribution', target: '_self' },
      { id: 'f-marketing', label: 'PR & Marketing', type: 'system', url: '/marketing', target: '_self' },
    ],
  },
  {
    id: 'menu-footer-company',
    name: 'Footer Studio & Legal',
    location: 'footer_col_2',
    updatedAt: new Date().toISOString(),
    items: [
      { id: 'fc-1', label: 'Home & Executive Team', type: 'system', url: '/#team' },
      { id: 'fc-2', label: 'About Stargaze Studio', type: 'system', url: '/about' },
      { id: 'fc-3', label: 'Production Capabilities', type: 'system', url: '/capabilities' },
      { id: 'fc-4', label: 'Worldwide Distribution', type: 'system', url: '/distribution' },
      { id: 'fc-5', label: 'Newsroom & Press', type: 'system', url: '/newsroom' },
      { id: 'fc-6', label: 'Contact & Enquiries', type: 'system', url: '/contact' },
    ],
  },
  {
    id: 'menu-mobile-overlay',
    name: 'Mobile & Overlay Menu',
    location: 'mobile_overlay',
    updatedAt: new Date().toISOString(),
    items: [
      { id: 'm-1', label: 'Home (with Team)', type: 'system', url: '/' },
      { id: 'm-2', label: 'Films', type: 'system', url: '/films' },
      { id: 'm-3', label: 'Events', type: 'system', url: '/events' },
      { id: 'm-4', label: 'Rental', type: 'system', url: '/rental' },
      { id: 'm-5', label: 'PR & Marketing', type: 'system', url: '/marketing' },
      { id: 'm-6', label: 'Work', type: 'system', url: '/work' },
      { id: 'm-7', label: 'Contact', type: 'system', url: '/contact' },
      { id: 'm-8', label: 'Newsroom', type: 'system', url: '/newsroom' },
      { id: 'm-9', label: 'Studio Capabilities', type: 'system', url: '/capabilities' },
      { id: 'm-10', label: 'Global Distribution', type: 'system', url: '/distribution' },
    ],
  },
];

export const INITIAL_THEME_CUSTOMIZER: ThemeCustomizerSettings = {
  header: {
    layout: 'standard',
    sticky: true,
    glassmorphism: true,
    logoHeight: 48,
    showPrimaryCta: true,
    primaryCtaText: 'START A PROJECT',
    primaryCtaLink: '/enquiry',
    showExploreButton: true,
    exploreButtonText: 'EXPLORE SCENES',
    bgColor: '#ffffff',
    textColor: '#3f3f46',
    accentColor: '#d97706',
  },
  footer: {
    layout: 'columns_4',
    tagline: 'Cinema • Production • Equipment • Distribution',
    copyrightText: `© ${new Date().getFullYear()} Stargaze Media Pvt. Ltd. All rights reserved.`,
    showNewsletter: true,
    newsletterHeading: 'THE STARGAZE JOURNAL',
    newsletterSubtext: 'Receive exclusive premiere invitations, festival announcements, and cinema technology insights.',
    showSocialIcons: true,
    showBackToTop: true,
    bgColor: '#09090b',
    textColor: '#a1a1aa',
    accentColor: '#d97706',
  },
  theme: {
    accentColorPreset: 'amber',
    customAccentHex: '#d97706',
    fontFamilyPreset: 'sans',
    borderRadiusPreset: 'lg',
    enableCustomCursor: true,
    enableSmoothTransitions: true,
  },
  customCss: '',
  customHeadCode: '',
  updatedAt: new Date().toISOString(),
};

